import * as React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';

import './App.scss';

import Navigation from './navigation';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { requestForToken, onMessageListener } from './firebase';
import WebService from './Services/WebService';
import { setMeData } from './redux/reducers/AuthReducers';
const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lastToastRef = React.useRef<string | null>(null);
  const lastToastTimeRef = React.useRef<number>(0);

  const showToast = (message: string, orderId?: string) => {
    const now = Date.now();
    if (message === lastToastRef.current && now - lastToastTimeRef.current < 3000) {
      return;
    }
    lastToastRef.current = message;
    lastToastTimeRef.current = now;
    toast(message, { 
        toastId: message,
        onClick: () => {
            if (orderId) {
                navigate('/payment-details', { state: { orderId } });
            }
        },
        closeOnClick: true,
        autoClose: 5000
    });
  };

  useEffect(() => {
    // Re-fetch "me" data on app mount to restore Redux state after page refresh
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      WebService.getAPI({
        action: 'customer-auth/me',
        isHideToast: true,
        isHideError: true,
      })
        .then((res: any) => {
          dispatch(setMeData(res));
        })
        .catch(() => { });
    }
  }, []);

  useEffect(() => {
    requestForToken();
    
    // Subscribe to Firebase foreground messages
    const unsubscribeFromMessage = onMessageListener((payload: any) => {
      const message = payload?.notification?.body || payload?.data?.body;
      // rigorous check for order id
      const orderId = payload?.data?.order_id || payload?.data?.orderId;
      
      if (message) {
        showToast(message, orderId);
        window.dispatchEvent(new CustomEvent('fcm-notification', { detail: payload }));
      }
    });

    const messageHandler = (event: MessageEvent) => {
        if (event.data && typeof event.data === 'object') {
             const payload = event.data;
             
             if (payload.type === 'NOTIFICATION_CLICK') {
                 const orderId = payload.order_id || payload.orderId;
                 if (orderId) {
                     navigate('/payment-details', { state: { orderId } });
                 } else {
                     console.error('Missing orderId in NOTIFICATION_CLICK payload');
                 }
                 return;
             }

             const message = payload?.notification?.body || payload?.data?.body || payload?.body;
             const orderId = payload?.data?.order_id || payload?.data?.orderId || payload?.order_id || payload?.orderId;

             if(message){
                  showToast(message, orderId);
                  window.dispatchEvent(new CustomEvent('fcm-notification', { detail: payload }));
             }
        }
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', messageHandler);
    }

    return () => {
        if(unsubscribeFromMessage){
            unsubscribeFromMessage();
        }
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.removeEventListener('message', messageHandler);
        }
    };
  }, []);
  return (
    <>
      <div className="App">
        <Navigation />
        <ToastContainer />
      </div>
    
    </>
  );
};
export default App;
